import React, { Component } from "react";

import styles from "./styles.module.css";

import Header from "../../../../../components/Header";
import Modal from "../../../../../components/Modal";
import ButtonLoading from "../../../../../components/Buttons/ButtonLoading";
import Button from '../../../../../components/Buttons/Button';

import { Form, Col, Row } from "react-bootstrap";
import MaskedFormControl from '../../../../../components/Inputs/react-bootstrap-maskedinput'

import api from "../../../../../services/api";
import { API_GUARD } from "../../../../../services/env";
import MultiSelect from "../../../../../components/Inputs/Bootstrap/MultiSelect";

export default class EditTelephone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: "",
      reserved: false,
      providers: [],
      cities: [],
      validate: {
        number: {
          message: "",
          isInvalid: false
        },
        provider_id: {
          message: "",
          isInvalid: false
        },
        city_id: {
          message: "",
          isInvalid: false
        }
      },

      isLoadingForm: true,
      advancedToggled: false,

      isLoading: false,
      isAlertOn: false,
      forgotModal: false,

      alertMessage: {
        title: "",
        message: ""
      }
    };
    this.getEditTelephone = this.getEditTelephone.bind(this);
  }

  componentDidMount() {
    this.getCreateTelephone();
    this.getEditTelephone();
  }

  clearForm() {
    this.setState({
      number: "",
      provider_id:"",
      city_id: "",
      reserved: false,
      validate: {
        number: {
          message: "",
          isInvalid: false
        },
        provider_id: {
          message: "",
          isInvalid: false
        },
        city_id: {
          message: "",
          isInvalid: false
        }
      },

    });
  }

  async getCreateTelephone() {
    this.toggleIsLoadForm(true);
    const access_token = await localStorage.getItem("access_token");
    const response = await api.get(`/v1/${API_GUARD}/telephones/create`, {
      headers: { Authorization: "Bearer " + access_token }
    });

    if (response.status === 200) {
      const { providers,cities } = response.data;

      this.setState({ providers,cities });
    }
    this.toggleIsLoadForm(false);
  }

  async getEditTelephone() {
    this.toggleIsLoadForm(true);
    const { params } = this.props.match;
    const access_token = await localStorage.getItem("access_token");
    const response = await api.get(`/v1/${API_GUARD}/telephones/${params.id}/edit`, {
      headers: { Authorization: "Bearer " + access_token }
    });

    if (response.status === 200) {
      const { telephone } = response.data;
      const { number,provider_id,city_id, reserved } = telephone;
      this.setState({ number,provider_id,city_id, reserved });
    }
    this.toggleIsLoadForm(false);
  }

  toggleAlert(boolean) {
    this.setState(prevState => {
      return {
        isAlertOn: boolean
      }
    });
    const { history } = this.props;
    history.push(`/admin/PABX/telefones`);
  }

  toggleIsLoad(boolean) {
    this.setState({ isLoading: boolean });
  }

  toggleIsLoadForm(boolean) {
    this.setState({ isLoadingForm: boolean });
  }

  activeAlert(alertMessage) {
    const { title, message } = alertMessage;
    this.setState({
      ...this.state,
      isAlertOn: true,
      alertMessage: {
        title,
        message
      }
    });
  }

  error() {
    const alert = {
      title: "Ops... Algo deu errado.",
      message: "Não foi possível completar sua requisição."
    }
    this.activeAlert(alert);
  }

  handlerChangeInput(value) {
    const key = Object.keys(value)[0];
    this.setState({
      ...value,
      validate: {
        ...this.state.validate,
        [key]: {
          message: "",
          isInvalid: false
        }
      }
    });
  }

  async handlerUpdate(event) {
    event.preventDefault();
    const { params } = this.props.match;
    if (!this.state.isLoading) {
      this.toggleIsLoad(true);
      // const { history } = this.props;
      const {
        number,
        provider_id,
        reserved,
        city_id
      } = this.state;
      try {
        const access_token = await localStorage.getItem("access_token");
        const response = await api.put(
          `/v1/${API_GUARD}/telephones/${params.id}`,
          {
            number,provider_id,city_id,reserved
          },
          {
            headers: { Authorization: "Bearer " + access_token }
          }
        );
        if (response.status && response.status === 200) {
          const { title, message } = response.data;
          this.activeAlert({ title, message });
        }
        this.toggleIsLoad(false);
      } catch (error) {
        if (error.response) {
          switch (error.response.status) {
            case 400:
              const { title, message } = error.response.data;
              this.activeAlert({ title, message });
              break;
            case 422:
              const { errors } = error.response.data;
              for (let key in errors) {
                this.setState({
                  validate: {
                    ...this.state.validate,
                    [key]: {
                      message: errors[key],
                      isInvalid: true
                    }
                  }
                });
              }
              break;
            default:
              this.error();
            // 
          }
        }
        this.toggleIsLoad(false);
      }
    }
  }

  render() {
    const {
      number,
      providers,
      cities,
      cleanMultiSelect,
      isLoadingForm,
      provider_id,
      reserved,
      city_id,
      validate,
      isAlertOn
    } = this.state;

    const alignLabel = {
      xs: { span: 3 },
      sm: { offset: 2, span: 1 },
      md: { offset: 2, span: 1 },
      lg: { offset: 2, span: 1 }
    };
    const alignInput = {
      xs: { span: 8 },
      sm: { span: 7 },
      md: { span: 7 },
      lg: { span: 7 }
    };

    return (
      <div className={`${styles.container}`}>
        <Header title="Telefones" description="Telefones para PABX" />
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <h2 className={styles.cardTitle}>Editar Telefone</h2>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.formContainer}>
              <Form
                onSubmit={event => this.handlerUpdate(event)}
                className={styles.form}
                ref="form"
              >
                <Form.Group as={Row} controlId="cities">
                  <Form.Label
                    column
                    xs={alignLabel.xs} md={alignLabel.md}
                  >
                    Cidade:
                            </Form.Label>
                  <Col
                    xs={alignInput.xs} md={alignInput.md}
                  >
                    <MultiSelect
                      disabled={true}
                      cleanMultiSelect={cleanMultiSelect}
                      isLoading={isLoadingForm}
                      defaultSelected={[{ id: city_id }]}
                      isInvalid={validate.city_id.isInvalid}
                      multiple={false}
                      label="name"
                      placeholder="Selecione uma cidade..."
                      options={cities}
                      onChange={event => {
                        // event.length > 0
                        //   ? this.handlerChangeInput({ city_id: event[0].id })
                        //   : this.handlerChangeInput({ city_id: "" })
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validate.city_id.message}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalNumber">
                  <Form.Label column xs={alignLabel.xs} md={alignLabel.md}>
                    Telefone:
                  </Form.Label>
                  <Col xs={alignInput.xs} md={alignInput.md}>
                    <MaskedFormControl
                      disabled={true}
                      mask={(
                        number ?
                          (number.length < 9 ? '9999-99999'
                            : '9 9999-9999')
                          : '9999-99999'
                      )}
                      // placeholderChar=" "
                      className={validate.number.isInvalid && "is-invalid"}
                      type="tel"
                      name="number"
                      min={10000000}
                      max={999999999}
                      value={number}
                      placeholder="Número do telefone"
                      onChange={event => {
                        // this.handlerChangeInput({
                        //   number: event.target.value.replace(/\D/g, "")
                        // })
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validate.number.message}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="providers">
                  <Form.Label
                    column
                    xs={alignLabel.xs} md={alignLabel.md}
                  >
                    Fornecedor:
                            </Form.Label>
                  <Col
                    xs={alignInput.xs} md={alignInput.md}
                  >
                    <MultiSelect
                      cleanMultiSelect={cleanMultiSelect}
                      isLoading={isLoadingForm}
                      defaultSelected={[{ id: provider_id }]}
                      isInvalid={validate.provider_id.isInvalid}
                      multiple={false}
                      label="name"
                      placeholder="Selecione um fornecedor..."
                      options={providers}
                      onChange={event => {
                        event.length > 0
                          ? this.handlerChangeInput({ provider_id: event[0].id })
                          : this.handlerChangeInput({ provider_id: "" })
                      }
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {validate.provider_id.message}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                 <Form.Group as={Row} controlId="reserved">
                  <Form.Label column xs={alignLabel.xs} md={alignLabel.md}>
                    Telefone reservado:
                  </Form.Label>
                  <Col xs={alignInput.xs} md={alignInput.md}>
                    <Form.Group controlId="formBasicCheckbox">
                      <Form.Check
                        type="checkbox"
                          value={reserved}
                        checked={this.state.reserved}
                        onChange={event => {
                          this.handlerChangeInput({
                            reserved: event.target.checked
                          });
                        }
                        }
                      />
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Col sm={{ span: 12 }} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', }}>
                    <Button text='Voltar' arrowLeft={true} btnClass="btn-back-radius"  onClick={this.props.history.goBack}/>
                    <ButtonLoading
                      isLoading={this.state.isLoading}
                      text="Atualizar"
                    />
                  </Col>
                </Form.Group>
              </Form>
            </div>
            <Modal
              isActive={isAlertOn}
              toggleAlert={(boolean) => this.toggleAlert(boolean)}
              title={this.state.alertMessage.title}
              text={this.state.alertMessage.message}
            />
          </div>
        </div>
      </div >
    );
  }
}
